export const STATIC_WIZARD_COMPONENTS = {
  wizardQuestions: 'KeuzehulpJsonKeuzehulpResultPageMainQuestions',
  radioGroup: 'radio-group',
  checkboxGroup: 'checkbox-group',
  wizardAside: 'wizard-aside',
};

export const STATIC_WIZARD_ASIDE_STATE = {
  default: 'initial',
};

export const STATIC_WIZARD_PACKAGES = {
  packageSmart: 'pakket-slim',
  packageAmbitious: 'pakket-ambitieus',
  packageLimitless: 'pakket-grenzeloos',
};

export const STATIC_WIZARD_PARAMS = {
  openDomain: 'opendomain',
  default: 'default',
};

export const STATIC_WIZARD_PARAMS_KEYS = {
  userFrom: 'userfrom',
};
